import { render } from "./Komparator.vue?vue&type=template&id=03d2b140&scoped=true"
import script from "./Komparator.vue?vue&type=script&lang=js"
export * from "./Komparator.vue?vue&type=script&lang=js"

import "./Komparator.vue?vue&type=style&index=0&id=03d2b140&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03d2b140"

export default script